export const getViewportStorageKey = (flowId: string) =>
  `banani-flow-viewport-${flowId}`;

export const getLastSelectedScreenStorageKey = (flowId: string) =>
  `banani-flow-lastSelectedScreenId-${flowId}`;
